import { Component } from "@angular/core";

@Component({
  selector: "tenant",
  templateUrl: "./tenant.component.html",
  styleUrls: ["./tenant.component.scss"],
})
export class TenantComponent {
  constructor() {}
}
